<template>
  <v-menu offset-y origin="right top" min-width="50px" transition="scale-transition">
    <template v-slot:activator="{ on }">
      <v-img
        src="/images/home/language.png" 
        v-on="on"
        class="app-lang"
        style="margin: 0px 0 0 auto;"
      > <div class="app-lang-text">{{ getCurrentLang }}</div></v-img>
    </template>
    <v-list>
      <v-list-item @click="setLang('cn_tw')">
        <v-list-item-title>繁體</v-list-item-title>
      </v-list-item>
      <v-list-item @click="setLang('cn_zh')">
        <v-list-item-title>简体</v-list-item-title>
      </v-list-item>
      <v-list-item @click="setLang('en')">
        <v-list-item-title>Eng</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  computed: {
    getCurrentLang() {
      if (this.$i18n.locale == "cn_tw") return "繁體";
      if (this.$i18n.locale == "cn_zh") return "简体";
      return "Eng";
    }
  },
  methods: {
    setLang: function(lang) {
      // update cookie before send request
      document.cookie = `locale=${lang};path=/`;
      localStorage["locale"] = lang;
      //this.$store.dispatch("setLang", lang);
      window.location.reload();

      if (lang == "en") {
        localStorage["applocale"] = "en";
      } else if (lang == "cn_zh") {
        localStorage["applocale"] = "zh_CN";
      } else if (lang == "cn_tw") {
        localStorage["applocale"] = "zh_TW";
      }
    }
  }
};
</script>
<style lang="scss">
.app-lang {
  max-width: 50px;
  max-height: 50px;
  .v-responsive__content {
    display: table !important;
    width: 50px;
    height: 50px;
  }
  .app-lang-text {
    display: table-cell;
    vertical-align: middle;
    text-align: center;
  }
}

@media (max-width: 500px) {
  .app-lang {
    max-width: 35px;
    max-height: 35px;
    .v-responsive__content {
      width: 35px;
      height: 35px;
    }
  }
  .app-lang-text {
    font-size: 12px;
  }
}

</style>